import './ActionsControls.css';
import { jsx as r } from "react/jsx-runtime";
import c from "clsx";
import f, { forwardRef as _ } from "react";
const d = "_popup_16umj_1", A = "_item_16umj_13", n = {
  popup: d,
  item: A
}, p = _(
  ({ actions: t, className: e = "" }, s) => {
    if (!t.length)
      return null;
    const m = c({
      [n.popup]: !0,
      [e]: !!e
    });
    return /* @__PURE__ */ r("div", { className: m, ref: s, children: t.map(({ render: u, onClick: o, disabled: a }, i) => a ? null : /* @__PURE__ */ r(
      "button",
      {
        className: n.item,
        onClick: (l) => {
          l.stopPropagation(), o == null || o();
        },
        children: u()
      },
      i
    )) });
  }
);
p.displayName = "ActionsControlsComponent";
const N = f.memo(p);
export {
  N as A
};
//# sourceMappingURL=ActionsControls-BrOv771p.js.map
